import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { FileText, ChevronUp, ChevronDown, List } from 'lucide-react';
import './BoardDetail.scss';

const BoardDetail = ({ post, allPosts = [], onBack, onChangePost }) => {
  const isNotice = useMemo(() => post?.board_type === 'notice' || !post?.type, [post]);
  const isRequest = useMemo(() => post?.type === 'sample' || post?.type === 'quote', [post]);

  const [detail, setDetail] = useState(isRequest ? post : null);

  const currentIndex = allPosts.findIndex((item) => item.id === post?.id);
  const nextPost = currentIndex > -1 ? allPosts[currentIndex - 1] : null;
  const prevPost = currentIndex > -1 ? allPosts[currentIndex + 1] : null;

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        if (isNotice && post?.id) {
          const res = await axios.get(`/api/user/boards/${post.id}`);
          setDetail(res.data);
        } else if (isRequest) {
          setDetail(post);
        }

        window.scrollTo(0, 0);
      } catch (err) {
        console.error('상세 로드 실패:', err);
      }
    };

    fetchDetail();
  }, [post, isNotice, isRequest]);

  if (!detail) return <div className="loading">데이터 로딩 중...</div>;

  if (isRequest) {
    return (
      <div className="board-detail-container">
        <div className="detail-header">
          <div className="category-badge">{detail.type === 'quote' ? '견적요청' : '샘플요청'}</div>
          <h2>{detail.title}</h2>
          <div className="meta-info">
            <span>
              <b>작성자</b> {detail.author_name}
            </span>
            <span>
              <b>등록일</b> {new Date(detail.created_at).toLocaleDateString()}
            </span>
            <span>
              <b>상태</b> {detail.status === 'completed' ? '답변완료' : '접수대기'}
            </span>
          </div>
        </div>

        <div className="detail-body">
          <div className="text-content">
            <p>
              <b>사용용도</b> {detail.use_purpose || '-'}
            </p>
            <p>
              <b>제품</b> {detail.product_name || '-'}
            </p>
            <p>
              <b>회사</b> {detail.company_name || '-'}
            </p>
            <p>
              <b>성명</b> {detail.author_name || '-'}
            </p>
            <p>
              <b>연락처</b> {detail.author_phone || '-'}
            </p>
            <p>
              <b>이메일</b> {detail.author_email || '-'}
            </p>

            {detail.type === 'quote' ? (
              <p>
                <b>수량</b> {detail.quantity || '-'}
              </p>
            ) : (
              <p>
                <b>주소</b> {detail.content || '-'}
              </p>
            )}

            {detail.type === 'quote' && (
              <p>
                <b>요청내용</b> {detail.content || '-'}
              </p>
            )}

            {detail.admin_comment ? (
              <>
                <br />
                <p>
                  <b>관리자 답변</b>
                </p>
                <p>{detail.admin_comment}</p>
              </>
            ) : null}
          </div>
        </div>

        <div className="detail-footer">
          <button className="btn-list-go" onClick={onBack}>
            <List size={18} /> 목록으로
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="board-detail-container">
      <div className="detail-header">
        <div className="category-badge">공지사항</div>
        <h2>{detail.title}</h2>
        <div className="meta-info">
          <span>
            <b>작성자</b> 관리자
          </span>
          <span>
            <b>등록일</b> {new Date(detail.created_at).toLocaleDateString()}
          </span>
          <span>
            <b>조회수</b> {detail.view_count}
          </span>
        </div>
      </div>

      <div className="detail-body">
        <div className="text-content">
          {detail.content?.split('\n').map((line, i) => (
            <span key={i}>
              {line}
              <br />
            </span>
          ))}
        </div>
      </div>

      {detail.file_url && (
        <div className="file-download-box">
          <div className="label">
            <FileText size={16} /> 첨부파일
          </div>
          <a href={`${detail.file_url}`} download className="file-name">
            {detail.file_url.split('/').pop()}
          </a>
        </div>
      )}

      <div className="post-navigation">
        <div
          className={`nav-row next ${!nextPost ? 'disabled' : ''}`}
          onClick={() => nextPost && onChangePost(nextPost)}
        >
          <span className="nav-label">
            <ChevronUp size={16} /> 다음글
          </span>
          <span className="nav-subject">{nextPost ? nextPost.title : '다음글이 없습니다.'}</span>
        </div>
        <div
          className={`nav-row prev ${!prevPost ? 'disabled' : ''}`}
          onClick={() => prevPost && onChangePost(prevPost)}
        >
          <span className="nav-label">
            <ChevronDown size={16} /> 이전글
          </span>
          <span className="nav-subject">{prevPost ? prevPost.title : '이전글이 없습니다.'}</span>
        </div>
      </div>

      <div className="detail-footer">
        <button className="btn-list-go" onClick={onBack}>
          <List size={18} /> 목록으로
        </button>
      </div>
    </div>
  );
};

export default BoardDetail;
